import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { useEffect } from "react";
import { ChatMessageArea } from "~/components/common/chat/messages/ChatMessageArea";
import { ChatPostArea } from "~/components/common/chat/post/ChatPostArea";
import type { Deal } from "~/models/Deal";
import type { Message, MessageReceiver } from "~/models/Message";
import Styles from "./ChatPageContainer.module.scss";

type Props = DeepReadonly<{
	deal: Deal;
	handleMutate: () => Promise<void>;
	messages: Message[];
	receiver?: MessageReceiver;
}>;

/**
 * スマホなどで画面いっぱいに表示するチャット画面
 *
 * @param deal
 * @param messages
 * @param handleMutate
 * @param receiver メッセージの受信者
 * @constructor
 */
export function ChatPageContainer({
	deal,
	messages,
	handleMutate,
	receiver = "maintenance_company"
}: Props) {
	useEffect(() => {
		window.scrollTo({ top: document.body.scrollHeight });
	}, [messages.length]);

	return (
		<>
			<div className={Styles.ChatPageContainer}>
				<ChatMessageArea
					deal={deal}
					handleMutate={handleMutate}
					isOpen
					messages={messages}
					receiver={receiver}
				/>
			</div>
			<ChatPostArea
				deal={deal}
				handleMutate={handleMutate}
				isVendor={receiver !== "maintenance_company"}
			/>
		</>
	);
}
